module.exports = __webpack_public_path__ + "static/img/login_bg.55162a5d.png";